import { useEffect } from "react"
import React from "react"
import { Outlet, useNavigate } from "react-router-dom"
import { organizationOnboardingPath } from "../novus-paths"
import { useCurrentOrganization } from "../hooks/useCurrentOrganization"

export const RequireUserVerified = () => {
  const navigate = useNavigate()
  const { loading, membership } = useCurrentOrganization()

  useEffect(() => {
    if (!membership || membership.verified) return

    navigate(organizationOnboardingPath({}))
  }, [membership, navigate])

  if (loading) {
    return null
  }

  return <Outlet />
}
